module.exports = __webpack_public_path__ + "ff9458729851b126af8a066b95f0e01b.png";